import { useEffect } from "react";
import { AppToasterV2, MultiStepItemProps } from "@ucl/library";
import { useFinancialApplicationFormSectionValidation } from "@/hooks/useFinancialApplicationFormSectionValidation";
import { FinancialApplicationSection } from "@/types/enums";
import { RequireAuth } from "@/lib/auth/RequireAuth";
import { OrganizationInfoForm } from "./OrganizationInfoForm";
import { FinancialApplicationFormSectionContextType } from "@/hooks/useFinancialApplicationFormSectionValidation";

export interface OrganizationInfoFormStepProps extends MultiStepItemProps {
  financialApplicationId: string;
}

export const OrganizationInfoFormStep: React.FC<OrganizationInfoFormStepProps> = (props) => {
  return (
    <RequireAuth clientType="consumer">
      <OrganizationInfoFormStepInner {...props} />
    </RequireAuth>
  );
};

const OrganizationInfoFormStepInner: React.FC<OrganizationInfoFormStepProps> = (props) => {
  const { validateFinancialApplicationFormSection } = useFinancialApplicationFormSectionValidation(
    props.financialApplicationId,
    FinancialApplicationSection.OrganizationInformation
  );

  useEffect(() => {
    props.registerSubmit?.(async () => {
      const { isValid } = await validateFinancialApplicationFormSection();

      if (!isValid) {
        AppToasterV2.showFailedActionToaster(
          "Please correct the highlighted fields to proceed.",
          "Action Required"
        );
        return false;
      }
      return true;
    });
  }, [props.financialApplicationId, validateFinancialApplicationFormSection]);

  return (
    <section className="organization-info step-section">
      <div className="organization-info__header step-header">Entity Information</div>
      <div className="organization-info__subtitle step-subtitle">
        Please provide your entity information and contact details for verification and communication purposes.
      </div>
      <div className="organization-info-form__content step-content">
        <OrganizationInfoForm
          financialApplicationId={props.financialApplicationId} 
          validationContextType={FinancialApplicationFormSectionContextType.Applicant}
          showHeader={true}
        />
      </div>
    </section>
  );
};
